var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopwatchQuarter = function SvgStopwatchQuarter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.121 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#43321e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.062 26A11.052 11.052 0 0 1 2.629 7.811a.61.61 0 0 0-.034-.822l-.826-.826a.6.6 0 0 0-.429-.178.6.6 0 0 0-.431.185l-.278.287a.37.37 0 0 1-.518 0 .37.37 0 0 1 0-.521l1.943-1.943a.368.368 0 0 1 .524.518l-.287.278a.607.607 0 0 0-.007.866l.826.826a.606.606 0 0 0 .823.033 10.9 10.9 0 0 1 6.2-2.578.607.607 0 0 0 .557-.605V1.336a.607.607 0 0 0-.607-.607h-.972a.365.365 0 1 1 0-.729h3.886a.365.365 0 1 1 0 .729h-.971a.607.607 0 0 0-.607.607v1.992a.61.61 0 0 0 .557.605 11.052 11.052 0 0 1-.915 22.066Zm-.006-21.38a10.323 10.323 0 1 0 10.323 10.319A10.335 10.335 0 0 0 11.056 4.62",
    "data-name": "Path 300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 5.831a9.2 9.2 0 0 0-9.165 8.44l-.031.756h9.2Z",
    "data-name": "Path 301"
  }))));
};
export default SvgStopwatchQuarter;